<template>
  <div class="conten">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="secah.idCardNumber" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="secah.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="secah.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="secah.projectName" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="申请状态" label-width='100px'>
          <el-select clearable v-model="secah.state" placeholder="请选择项目状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="申请中" :value="0"></el-option>
            <el-option label="申请成功" :value="1"></el-option>
            <el-option label="申请失败" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click='secahClick'>搜索</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="appUserId" label="用户id" align="center"></el-table-column>
        <el-table-column prop="projectId" label="项目id" align="center"></el-table-column>
        <el-table-column prop="idCardNumber" label="身份证号" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="phone" label="电话" align="center"></el-table-column>
        <el-table-column prop="supportTicket" label="支持份额（1份额 = 0.07元）" align="center"></el-table-column>
        <el-table-column prop="voucherPic" label="凭证图片" align="center">
          <template slot-scope="scope">
            <viewer>
              <img :src="webUrl + scope.row.voucherPic" style="height: 60px">
            </viewer>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="申请状态" align="center">
          <template slot-scope="scope">
            {{getState(scope.row.state)}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="申请时间" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button type="success" v-if="scope.row.state==0" size="mini" @click="refuseWithdrawal(scope.row, 1)">申请通过</el-button>
            <el-button type="danger" v-if="scope.row.state==0" size="mini" @click="refuseWithdrawal(scope.row, 2)">拒绝申请</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="审核原因" :visible.sync="isreason" :modal-append-to-body='false' width="600px">
      <el-form>
        <el-form-item label="审核原因" label-width='80px'>
          <el-input type="textarea" v-model="reason" maxlength="10" autocomplete="off" placeholder="请输入审核原因">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isreason = false">取 消</el-button>
        <el-button type="primary" @click="sub">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const defaultRowQuery = {
  projectName: '',
  detailTitle: '',
  projectPic: '',
  targetQuota: '',
  detailContent: '',
}
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      secah: {
        pageSize: 10,
        pageNum: 1,
        projectName: '',
        state: '',
        idCardNumber: '',
        name: '',
        phone: '',
      },
      isreason: false,
      reason: '',
      handleRow: {},
      handleState: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    //搜索
    secahClick() {
      this.secah.pageNum = 1
      this.getList()
    },
    getState(state) {
      if (state == 0) {
        return '申请中'
      } else if (state == 1) {
        return '申请成功'
      } else if (state == 2) {
        return '申请失败'
      }
    },
    //选择分页条数
    handleSizeChange(e) {
      this.secah.pageNum = 1
      this.secah.pageSize = e
      this.getList()
    },
    //页码
    handleCurrentChange(e) {
      this.secah.pageNum = e
      this.getList()
    },
    //获取数据
    getList() {
      var secah = this.secah
      this.httpGet(
        '/admin/physicalCloudLedger/supportApplyList',
        secah,
        true
      ).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.list
          this.total = res.data.total
        }
      })
    },
    //拒绝通过商家审核
    refuseWithdrawal(row, handleState) {
      this.isreason = true
      this.handleRow = row
      this.handleState = handleState
      this.reason = ''
    },
    //确定拒绝通过商家审核
    sub() {
      let params = {
        supportId: this.handleRow.id,
        remark: this.reason,
        state: this.handleState,
      }
      this.httpPost(
        '/admin/physicalCloudLedger/auditSupportApply',
        params,
        true,
        { 'Content-Type': 'application/json' }
      ).then((res) => {
        if (res.code == 200) {
          this.$message.success('审核成功')
          this.isreason = false
          this.isDetails = false
          this.getList()
        }
      })
    },
  },
}
</script>

<style scoped lang='scss'>
.page {
  padding: 20px 0;
}
</style>
